import { render, staticRenderFns } from "./CustomersDataTableForLazyWithResize.vue?vue&type=template&id=a18c16e6&scoped=true"
import script from "./CustomersDataTableForLazyWithResize.vue?vue&type=script&lang=js"
export * from "./CustomersDataTableForLazyWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18c16e6",
  null
  
)

export default component.exports